import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import {addLocale} from "primereact/api";
import {Field, Form} from "react-final-form";
import {classNames} from "primereact/utils";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Dialog} from "primereact/dialog";
import moment from "moment";
import {closeMercureSubscription, openMercureSubscription} from "../../util/mercure";

const _FM_ReservationGuestFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    reservation: id
  });
  const [newFormData, setNewFormData] = useState({});
  const [originalFormData, setOriginalFormData] = useState({});
  const [countries, setCountries] = useState([]);
  const [publicReservation, setPublicReservation] = useState({});
  const [requiredFields, setRequiredFields] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [customerId, setCustomerId] = useState();
  const [existingCustomerId, setExistingCustomerId] = useState();

  const [CFormData, setCFormData] = useState({});
  const [COptions, setCOptions] = useState({});
  const [CFields, setCFields] = useState([]);
  const [showCFieldsDialog, setShowCFieldsDialog] = useState(false);
  const [savedGuestId, setSavedGuestId] = useState();
  const [savedGuestCountryRecordId, setSavedGuestCountryRecordId] = useState();

  const getCountrySpecificKey = () => Object.keys(props?.reservation?._country_specifics || {})[0]?.toLowerCase();
  const getCountrySpecificEntity = () => {
    const key = getCountrySpecificKey();
    return key ? `guest_${key}s` : null;
  };

  const getGuestCountryRecordId = (guestData) => {
    const guestCountryEntity = getCountrySpecificEntity();
    return guestCountryEntity && guestData?.[guestCountryEntity]?.[0]
      ? guestData[guestCountryEntity][0].id
      : null;
  };

  const fetchGuestCountryRecordId = (guestId, attempt = 1) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + guestId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setFormData(response.data.data);
        setOriginalFormData(response.data.data);
        setNewFormData({});

        const countryRecordId = getGuestCountryRecordId(response.data.data);
        if (!countryRecordId && attempt < 3) {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve(fetchGuestCountryRecordId(guestId, attempt + 1));
            }, 500);
          });
        }

        return countryRecordId;
      });
  };

  const getGuestCountrySaveConfig = () => {
    const countrySpecificKey = getCountrySpecificKey();
    if (!countrySpecificKey) {
      return null;
    }
    return {
      endpoint: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest-" + countrySpecificKey,
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    };
  };

  const navigateAfterGuestSave = () => {
    setLoading(false);
    if (window.location.hash.toString().includes('#/reservation')) {
      navigate('/reservation/' + action + '/' + id);
    }
    if (window.location.hash.toString().includes('#/calendar')) {
      navigate('/calendar/' + action + '/' + id);
    }
    window.App.setState({rerenderReservationGuestList: Math.random()});
  };

  const onGuestSaved = (guestId, countryRecordId) => {
    if (!guestId) {
      navigateAfterGuestSave();
      return;
    }

    const openCountrySpecificDialog = (resolvedCountryRecordId) => {
      setSavedGuestId(guestId);
      setSavedGuestCountryRecordId(resolvedCountryRecordId);

      if (CFields && CFields[0]) {
        setShowCFieldsDialog(true);
        setLoading(false);
        return;
      }

      navigateAfterGuestSave();
    };

    if (CFields && CFields[0]) {
      if (countryRecordId) {
        openCountrySpecificDialog(countryRecordId);
        return;
      }

      fetchGuestCountryRecordId(guestId)
        .then(resolvedCountryRecordId => {
          if (resolvedCountryRecordId) {
            openCountrySpecificDialog(resolvedCountryRecordId);
            return;
          }

          setLoading(false);
          window.App.toastShow('error', t('error'), t('country_specific_settings_after_save'));
          navigateAfterGuestSave();
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
          navigateAfterGuestSave();
        });
      return;
    }

    navigateAfterGuestSave();
  };

  const saveGuestCountrySpecificData = () => {
    const saveConfig = getGuestCountrySaveConfig();
    if (!saveConfig || !savedGuestId) {
      setShowCFieldsDialog(false);
      navigateAfterGuestSave();
      return;
    }

    setLoading(true);

    const patchGuestCountrySpecificData = (countryRecordId) => {
      axios({
        method: 'patch',
        url: saveConfig.endpoint + "/" + countryRecordId,
        data: {
          ...CFormData
        },
        params: {},
        headers: saveConfig.headers
      })
        .then(() => {
          setShowCFieldsDialog(false);
          navigateAfterGuestSave();
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response);
        });
    };

    if (!savedGuestCountryRecordId) {
      fetchGuestCountryRecordId(savedGuestId)
        .then(resolvedCountryRecordId => {
          if (!resolvedCountryRecordId) {
            setLoading(false);
            window.App.toastShow('error', t('error'), t('country_specific_settings_after_save'));
            return;
          }

          setSavedGuestCountryRecordId(resolvedCountryRecordId);
          patchGuestCountrySpecificData(resolvedCountryRecordId);
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
        });
      return;
    }

    patchGuestCountrySpecificData(savedGuestCountryRecordId);
  };

  const validate = (data) => {
    let errors = {};
    if (requiredFields.includes('zipCode') && !data.zip_code) {
      errors.zip_code = 'Kötelező mező';
    }
    if (requiredFields.includes('firstname') && !data.firstname) {
      errors.firstname = 'Kötelező mező';
    }
    if (requiredFields.includes('lastname') && !data.lastname) {
      errors.lastname = 'Kötelező mező';
    }
    if (requiredFields.includes('gender') && !data.gender) {
      errors.gender = 'Kötelező mező';
    }
    if (requiredFields.includes('citizenship') && !data.citizenship) {
      errors.citizenship = 'Kötelező mező';
    }
    if (requiredFields.includes('residenceCountry') && !data.residence_country) {
      errors.residence_country = 'Kötelező mező';
    }
    if (requiredFields.includes('birthDate') && !data.birth_date) {
      errors.birth_date = 'Kötelező mező';
    }
    if (requiredFields.includes('birthPlace') && !data.birth_place) {
      errors.birth_place = 'Kötelező mező';
    }
    if (requiredFields.includes('idType') && !data.id_type) {
      errors.id_type = 'Kötelező mező';
    }
    if (requiredFields.includes('idNumber') && !data.id_number) {
      errors.id_number = 'Kötelező mező';
    }
    if (requiredFields.includes('zipCode') && !data.zip_code) {
      errors.zip_code = 'Kötelező mező';
    }
    if (requiredFields.includes('address') && !data.address) {
      errors.address = 'Kötelező mező';
    }
    if (requiredFields.includes('companyName') && !data.company_name) {
      errors.company_name = 'Kötelező mező';
    }
    if (requiredFields.includes('email') && !data.email) {
      errors.email = 'Kötelező mező';
    }
    if (requiredFields.includes('phone') && !data.phone) {
      errors.phone = 'Kötelező mező';
    }
    if (requiredFields.includes('note') && !data.note) {
      errors.note = 'Kötelező mező';
    }
    return errors;
  };

  const onSubmit = (data, form) => {
    setLoading(true);
    if (!formData?.id) {
      if (customerId) {
        let _data = formData;
        delete _data.id;
        delete _data.guests;
        axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest",
          {
            ..._data,
            status: "will_arrive",
            customer: customerId,
            reservation: id
          },
          {
            params: {},
            headers: {
              'Authorization': 'Bearer ' + Cookies.get("userToken"),
              "Sys-name": Cookies.get("instanceId"),
              "Preferred-locale": Cookies.get("language")
            }
          })
          .then(response => {
            setCustomerId()
            if (response?.data?.data?.id) {
              onGuestSaved(response.data.data.id);
              return;
            }
            const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
              + Cookies.get("instanceId") + "/new-entity";
            const eventSource = openMercureSubscription({
              topics: [topic],
            });
            if (!eventSource) {
              navigateAfterGuestSave();
              return;
            }
            const fallbackTimer = setTimeout(() => {
              closeMercureSubscription(eventSource);
              navigateAfterGuestSave();
            }, 15000);
            console.log('feliratkozás történt: ' + topic)
            eventSource.onmessage = (event) => {
              const data = JSON.parse(event.data);
              console.log('push notification arrived:');
              console.log(data)
              if ((data.entity === 'Guest' || data.entity === 'guest') && data.id) {
                clearTimeout(fallbackTimer);
                closeMercureSubscription(eventSource);
                onGuestSaved(data.id);
              }
            }
          })
          .catch(error => {
            setLoading(false)
            window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
          })
      } else {
        axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "public/reservation/customer/"
          + props.uniqueId + "/" + props.password,
          formData,
          {
            params: {},
            headers: {
              "Preferred-locale": Cookies.get("language"),
              "Sys-name": Cookies.get("instanceId"),
            }
          })
          .then(response => {
            const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
              + Cookies.get("instanceId") + "/new-entity";
            const eventSource = openMercureSubscription({
              topics: [topic],
            });
            if (!eventSource) {
              navigateAfterGuestSave();
              return;
            }
            const fallbackTimer = setTimeout(() => {
              closeMercureSubscription(eventSource);
              navigateAfterGuestSave();
            }, 15000);
            console.log('feliratkozás történt: ' + topic)
            eventSource.onmessage = (event) => {
              const data = JSON.parse(event.data);
              console.log('push notification arrived:');
              console.log(data)
              if ((data.entity === 'Guest' || data.entity === 'guest') && data.id) {
                clearTimeout(fallbackTimer);
                closeMercureSubscription(eventSource);
                onGuestSaved(data.id);
              }
            }
          })
          .catch(error => {
            setLoading(false)
            window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
          })
      }
    } else {
      const buildGuestPatchPayload = () => {
        const payload = {
          ...newFormData
        };
        const nextAdditionalAnswers = {
          ...(originalFormData?.additional_answers || {})
        };
        let hasCustomFieldChange = false;

        (customFields || []).forEach((field) => {
          if (field.related_to !== 'RELATED_TO_CUSTOMER') {
            return;
          }
          if (!Object.prototype.hasOwnProperty.call(payload, field.name)) {
            return;
          }
          hasCustomFieldChange = true;
          nextAdditionalAnswers[field.name] = {
            ...(nextAdditionalAnswers[field.name] || {}),
            value: payload[field.name] || ''
          };
          delete payload[field.name];
        });

        if (hasCustomFieldChange || (Object.keys(payload).length > 0 && originalFormData?.additional_answers)) {
          payload.additional_answers = nextAdditionalAnswers;
        }

        return payload;
      };

      const patchPayload = buildGuestPatchPayload();
      axios.patch(process.env.REACT_APP_API_PROTOCOL
        + process.env.REACT_APP_API_HOST + "guest/" + formData.id,
        patchPayload,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setOriginalFormData(response.data.data);
          setNewFormData({});
          const existingCountryRecordId = getGuestCountryRecordId(response.data.data);
          onGuestSaved(response.data.data.id, existingCountryRecordId);
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
  }

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  useEffect(() => {
    if (formData.firstname && formData.lastname && formData?.birth_date?.length === 10 && !formData.id) {
      setLoading(true)
      setTimeout(() => {
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer/exist"
            + "?firstname=" + formData.firstname + "&lastname=" + formData.lastname + "&birthDate=" + moment(formData.birth_date).format(t('YYYY-MM-DD')),
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
          .then(response => {
            if (response.data.data && response.data.data[0]) {
              setExistingCustomerId(response.data.data[0])
              window.App.setState({confirmExistingCustomerUse: true})
            } else {
              setExistingCustomerId()
            }
            setLoading(false)
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
            setExistingCustomerId()
            setLoading(false)
          })
      }, 500)
    }
  }, [formData.firstname, formData.lastname, formData.birth_date]);

  useEffect(() => {
    CFields.map((field, index) => {
      if (field.type.includes("Enum")) {
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/" + field.name.replaceAll('_', '-'),
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
          .then(response => {
            setCOptions({
              ...COptions,
              [field.name]: Object.values(response.data.data).flat()
            })
          })
          .catch(error => {

          })
      }
    })
  }, [CFields])

  useEffect(() => {
    const countrySpecificKey = Object.keys(props?.reservation?._country_specifics || {})[0]?.toLowerCase();
    const guestCountryEntity = countrySpecificKey ? `guest_${countrySpecificKey}s` : null;
    if (guestCountryEntity && formData[guestCountryEntity] && formData[guestCountryEntity][0]) {
      setCFormData({
        ...formData[guestCountryEntity][0]
      })
    }
  }, [formData, props.reservation])

  useEffect(() => {
    if (!props.reservation || !props.reservation._country_specifics) {
      setCFields([]);
      return;
    }

    const key = Object.keys(props.reservation._country_specifics)[0];
    const transformedCountry = key
      ? key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()
      : "";

    if (!transformedCountry) {
      setCFields([]);
      return;
    }

    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "info/Guest"
        + transformedCountry,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setCFields(response.data.editable_fields);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [props.reservation, t])


  useEffect(() => {
    if (window.App.urlVars().guestId) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + window.App.urlVars().guestId,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          setOriginalFormData(response.data.data);
          setNewFormData({});
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    if (props.uniqueId && props.password) {
      axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "public/reservation/"
        + props.uniqueId + "/" + props.password,
        {
          params: {},
          headers: {
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setPublicReservation(response.data.data)
          if (response.data.data && response.data.data.accommodation
            && response.data.data.accommodation.guest_information_request_page
            && response.data.data.accommodation.guest_information_request_page.customer_required_fields) {
            setRequiredFields(response.data.data.accommodation.guest_information_request_page.customer_required_fields)
          }
          if (response.data.data && response.data.data
            && response.data.data.guest_information_request_page
            && response.data.data.guest_information_request_page.girp_additional_fields) {
            setCustomFields(response.data.data.guest_information_request_page.girp_additional_fields)
          }
          setLoading(false)
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/country",
      params: {},
      headers: {
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        const allCountries = response.data.data;
        const prioritizedCountries = JSON.parse(process.env.REACT_APP_PRIORITIZEDCOUNTRIES || "[]");
        const sortedCountries = [
          ...allCountries.filter((country) => prioritizedCountries.includes(country.code)),
          ...allCountries.filter((country) => !prioritizedCountries.includes(country.code)),
        ];
        setCountries(sortedCountries);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, []);

  return (
    <>
      <ConfirmDialog group="declarative" visible={window.App.state.confirmExistingCustomerUse}
                     acceptLabel={t('yes')} rejectLabel={t('no')}
                     onHide={() => {
                       setExistingCustomerId()
                       window.App.setState({confirmExistingCustomerUse: false})
                     }}
                     message={
                       <>
                         {t('confirm_existing_customer_message')}
                         {existingCustomerId ? (
                           <>
                             <br/>
                             <br/>
                             {`${t('name')}: ${`${existingCustomerId.lastname || existingCustomerId.last_name || ''} ${existingCustomerId.firstname || existingCustomerId.first_name || ''}`.trim() || '-'}`}
                             <br/>
                             {`${t('birth_date')}: ${existingCustomerId.birth_date || existingCustomerId.birthDate
                               ? (moment(existingCustomerId.birth_date || existingCustomerId.birthDate).isValid()
                                 ? moment(existingCustomerId.birth_date || existingCustomerId.birthDate).format(t('YYYY-MM-DD'))
                                 : (existingCustomerId.birth_date || existingCustomerId.birthDate))
                               : '-'}`}
                             {(existingCustomerId.gender || existingCustomerId.sex) ? (
                               <>
                                 <br/>
                                 {`${t('gender')}: ${(() => {
                                   const value = `${existingCustomerId.gender || existingCustomerId.sex}`;
                                   const lower = t(value.toLowerCase());
                                   if (lower !== value.toLowerCase()) {
                                     return lower;
                                   }
                                   const exact = t(value);
                                   return exact !== value ? exact : value;
                                 })()}`}
                               </>
                             ) : null}
                             {(existingCustomerId.citizenship || existingCustomerId.nationality) ? (
                               <>
                                 <br/>
                                 {`${t('citizenship')}: ${(() => {
                                   const value = `${existingCustomerId.citizenship || existingCustomerId.nationality}`;
                                   const lower = t(value.toLowerCase());
                                   if (lower !== value.toLowerCase()) {
                                     return lower;
                                   }
                                   const exact = t(value);
                                   return exact !== value ? exact : value;
                                 })()}`}
                               </>
                             ) : null}
                             {existingCustomerId.birth_place ? (
                               <>
                                 <br/>
                                 {`${t('birth_place')}: ${existingCustomerId.birth_place}`}
                               </>
                             ) : null}
                             {(existingCustomerId.address || existingCustomerId.zip_code || existingCustomerId.city || existingCustomerId.residence_country) ? (
                               <>
                                 <br/>
                                 {`${t('address')}: ${[
                                   existingCustomerId.zip_code,
                                   existingCustomerId.city,
                                   existingCustomerId.address,
                                   existingCustomerId.residence_country ? (() => {
                                     const value = `${existingCustomerId.residence_country}`;
                                     const lower = t(value.toLowerCase());
                                     if (lower !== value.toLowerCase()) {
                                       return lower;
                                     }
                                     const exact = t(value);
                                     return exact !== value ? exact : value;
                                   })() : null
                                 ].filter(Boolean).join(' ')}`}
                               </>
                             ) : null}
                           </>
                         ) : null}
                       </>
                     }
                     header={t('confirm_existing_customer_title')} icon="pi pi-exclamation-triangle"
                     accept={() => {
                       if (!existingCustomerId) {
                         setExistingCustomerId()
                         window.App.setState({confirmExistingCustomerUse: false})
                         return;
                       }
                       setCustomerId(existingCustomerId.id)
                       axios({
                         method: 'get',
                         url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer/" + existingCustomerId.id,
                         params: {},
                         headers: {
                           'Authorization': 'Bearer ' + Cookies.get("userToken"),
                           "Sys-name": Cookies.get("instanceId"),
                           "Preferred-locale": Cookies.get("language")
                         }
                       })
                         .then(response => {
                           let _data = response.data.data;
                           delete _data.reservation;
                           delete _data.id;
                           setFormData({
                             ...formData,
                             ..._data
                           })
                         })
                         .catch(error => {

                         })
                         .finally(() => {
                           window.App.setState({confirmExistingCustomerUse: false})
                         })
                     }}
                     reject={() => {
                       setExistingCustomerId()
                       setCustomerId()
                       window.App.setState({confirmExistingCustomerUse: false})
                     }}/>
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"customer new"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                <h3>{t('guest_form')}</h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>
                {(!window.App.urlVars().guestId && !formData?.id) ? (
                  <Button type="submit"
                          label={t('add_new_guest')}
                          loading={loading}
                          icon={"pi pi-plus"}
                          className="p-button-success p-ml-2"/>
                ) : (
                  <Button type="submit"
                          label={t('save_modify_and_more_settings')}
                          loading={loading}
                          icon={"pi pi-save"}
                          className="p-button-success p-ml-2"/>
                )}
              </div>
            </div>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="lastname" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="lastname"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('lastname')}
                      &nbsp;
                      {requiredFields.includes('lastname') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                              <InputText id="lastname" {...input}
                                         onChange={(e) => {
                                           setFormData({
                                             ...formData,
                                             lastname: e.target.value
                                           });
                                           setNewFormData((prev) => {
                                             let _newFormData = {
                                               ...prev,
                                               lastname: e.target.value
                                             };
                                             if ((originalFormData.lastname ?? null) === (e.target.value ?? null)) {
                                               delete _newFormData.lastname;
                                             }
                                             return _newFormData;
                                           });
                                         }}
                                         value={formData.lastname}
                                         className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                            </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="firstname" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="firstname"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('firstname')}
                      &nbsp;
                      {requiredFields.includes('firstname') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                              <InputText id="firstname" {...input}
                                         onChange={(e) => {
                                           setFormData({
                                             ...formData,
                                             firstname: e.target.value
                                           });
                                           setNewFormData((prev) => {
                                             let _newFormData = {
                                               ...prev,
                                               firstname: e.target.value
                                             };
                                             if ((originalFormData.firstname ?? null) === (e.target.value ?? null)) {
                                               delete _newFormData.firstname;
                                             }
                                             return _newFormData;
                                           });
                                         }}
                                         value={formData.firstname}
                                         className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                            </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-4">
                <Field name="birth_date" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="birth_date"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('birth_date')}
                      &nbsp;
                      {requiredFields.includes('birthDate') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"birth_date"}
                                       mask={t('9999-99-99')}
                                       value={formData.birth_date}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           if (!e.value) {
                                             setFormData({
                                               ...formData,
                                               birth_date: null
                                             });
                                             setNewFormData((prev) => {
                                               let _newFormData = {
                                                 ...prev,
                                                 birth_date: null
                                               };
                                               if ((originalFormData.birth_date ?? null) === null) {
                                                 delete _newFormData.birth_date;
                                               }
                                               return _newFormData;
                                             });
                                             return;
                                           }
                                           const formattedBirthDate = moment.utc(e.value).local().format(t('YYYY-MM-DD'));
                                           const parsedBirthDate = moment(formattedBirthDate, t('YYYY-MM-DD'), true);
                                           if (!parsedBirthDate.isValid()) {
                                             return;
                                           }
                                           const minAllowedBirthYear = moment().year() - 99;
                                           if (parsedBirthDate.year() < minAllowedBirthYear) {
                                             window.App.customToastShow('warn', t('warning'), t('birth_date_too_old_warning'));
                                             return;
                                           }
                                           setFormData({
                                             ...formData,
                                             birth_date: formattedBirthDate
                                           });
                                           setNewFormData((prev) => {
                                             let _newFormData = {
                                               ...prev,
                                               birth_date: formattedBirthDate
                                             };
                                             if ((originalFormData.birth_date ?? null) === (formattedBirthDate ?? null)) {
                                               delete _newFormData.birth_date;
                                             }
                                             return _newFormData;
                                           });
                                         }
                                       }}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}
                            />
                            <Calendar
                              value={formData.birth_date ? moment(formData.birth_date, 'YYYY-MM-DD').toDate() : null}
                              locale="default"
                              dateFormat={t('YY-MM-DD')}
                              showIcon
                              onChange={(e) => {
                                if (!e.value) {
                                  setFormData({
                                    ...formData,
                                    birth_date: null
                                  });
                                  setNewFormData((prev) => {
                                    let _newFormData = {
                                      ...prev,
                                      birth_date: null
                                    };
                                    if ((originalFormData.birth_date ?? null) === null) {
                                      delete _newFormData.birth_date;
                                    }
                                    return _newFormData;
                                  });
                                  return;
                                }
                                const formattedBirthDate = moment.utc(e.value).local().format(t('YYYY-MM-DD'));
                                const parsedBirthDate = moment(formattedBirthDate, t('YYYY-MM-DD'), true);
                                if (!parsedBirthDate.isValid()) {
                                  return;
                                }
                                const minAllowedBirthYear = moment().year() - 99;
                                if (parsedBirthDate.year() < minAllowedBirthYear) {
                                  window.App.customToastShow('warn', t('warning'), t('birth_date_too_old_warning'));
                                  return;
                                }
                                setFormData({
                                  ...formData,
                                  birth_date: formattedBirthDate
                                });
                                setNewFormData((prev) => {
                                  let _newFormData = {
                                    ...prev,
                                    birth_date: formattedBirthDate
                                  };
                                  if ((originalFormData.birth_date ?? null) === (formattedBirthDate ?? null)) {
                                    delete _newFormData.birth_date;
                                  }
                                  return _newFormData;
                                });
                              }}/>
                          </div>
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="gender" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="gender"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('gender')}
                      &nbsp;
                      {requiredFields.includes('gender') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <Dropdown  options={[
                              {
                                name: t('male'),
                                value: 'MALE',
                              },
                              {
                                name: t('female'),
                                value: 'FEMALE',
                              },
                              {
                                name: t('other'),
                                value: 'OTHER',
                              }
                            ]}
                                      optionLabel="name"
                                      optionValue="value"
                                      id={"gender"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          gender: e.value
                                        });
                                        setNewFormData((prev) => {
                                          let _newFormData = {
                                            ...prev,
                                            gender: e.value
                                          };
                                          if ((originalFormData.gender ?? null) === (e.value ?? null)) {
                                            delete _newFormData.gender;
                                          }
                                          return _newFormData;
                                        });
                                      }}
                                      value={formData.gender}
                                      disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                            />
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="citizenship" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="citizenship"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('citizenship')}
                      &nbsp;
                      {requiredFields.includes('citizenship') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <Dropdown  options={countries}
                                      filter
                                      optionLabel="name"
                                      optionValue="code"
                                      id={"citizenship"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          citizenship: e.value
                                        });
                                        setNewFormData((prev) => {
                                          let _newFormData = {
                                            ...prev,
                                            citizenship: e.value
                                          };
                                          if ((originalFormData.citizenship ?? null) === (e.value ?? null)) {
                                            delete _newFormData.citizenship;
                                          }
                                          return _newFormData;
                                        });
                                      }}
                                      value={formData.citizenship}
                                      disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                            />
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <Field name="residence_country" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="residence_country"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('residence_country')}
                      &nbsp;
                      {requiredFields.includes('residenceCountry') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <Dropdown  options={countries}
                                      filter
                                      optionLabel="name"
                                      optionValue="code"
                                      id={"residence_country"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          residence_country: e.value
                                        });
                                        setNewFormData((prev) => {
                                          let _newFormData = {
                                            ...prev,
                                            residence_country: e.value
                                          };
                                          if ((originalFormData.residence_country ?? null) === (e.value ?? null)) {
                                            delete _newFormData.residence_country;
                                          }
                                          return _newFormData;
                                        });
                                      }}
                                      value={formData.residence_country}
                                      disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                            />
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>
            <div className={"p-grid"}>
              <div className="p-col-12 p-lg-6">
                <Field name="expected_check_in_at" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="expected_check_in_at"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {formData?.status?.toLowerCase() === 'checked_out'
                        ? t('arrived')
                        : formData?.status?.toLowerCase() === 'checked_in'
                          ? t('checked_in')
                          : t('expected_arrival')}
                    </label>
                    {(!formData.status || formData.status === 'will_arrive') &&
                      <span className="p-d-block">
                            <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"expected_check_in_at"}
                                       mask={t('9999-99-99')}
                                       value={formData.expected_check_in_at}
                                       disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           if (!e.value) {
                                             setFormData({
                                               ...formData,
                                               expected_check_in_at: null
                                             });
                                             setNewFormData((prev) => {
                                               let _newFormData = {
                                                 ...prev,
                                                 expected_check_in_at: null
                                               };
                                               if ((originalFormData.expected_check_in_at ?? null) === null) {
                                                 delete _newFormData.expected_check_in_at;
                                               }
                                               return _newFormData;
                                             });
                                             return;
                                           }
                                           const formattedCheckedInDate = moment.utc(e.value).local().format(t('YYYY-MM-DD'));
                                           const parsedCheckedInDate = moment(formattedCheckedInDate, t('YYYY-MM-DD'), true);
                                           if (!parsedCheckedInDate.isValid()) {
                                             return;
                                           }
                                           setFormData({
                                             ...formData,
                                             expected_check_in_at: formattedCheckedInDate
                                           });
                                           setNewFormData((prev) => {
                                             let _newFormData = {
                                               ...prev,
                                               expected_check_in_at: formattedCheckedInDate
                                             };
                                             if ((originalFormData.expected_check_in_at ?? null) === (formattedCheckedInDate ?? null)) {
                                               delete _newFormData.expected_check_in_at;
                                             }
                                             return _newFormData;
                                           });
                                         }
                                       }}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}
                            />
                            <Calendar
                              value={formData.expected_check_in_at ? moment(formData.expected_check_in_at, 'YYYY-MM-DD').toDate() : null}
                              locale="default"
                              dateFormat={t('YY-MM-DD')}
                              showIcon
                              disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                              onChange={(e) => {
                                if (!e.value) {
                                  setFormData({
                                    ...formData,
                                    expected_check_in_at: null
                                  });
                                  setNewFormData((prev) => {
                                    let _newFormData = {
                                      ...prev,
                                      expected_check_in_at: null
                                    };
                                    if ((originalFormData.expected_check_in_at ?? null) === null) {
                                      delete _newFormData.expected_check_in_at;
                                    }
                                    return _newFormData;
                                  });
                                  return;
                                }
                                const formattedCheckedInDate = moment.utc(e.value).local().format(t('YYYY-MM-DD'));
                                const parsedCheckedInDate = moment(formattedCheckedInDate, t('YYYY-MM-DD'), true);
                                if (!parsedCheckedInDate.isValid()) {
                                  return;
                                }
                                setFormData({
                                  ...formData,
                                  expected_check_in_at: formattedCheckedInDate
                                });
                                setNewFormData((prev) => {
                                  let _newFormData = {
                                    ...prev,
                                    expected_check_in_at: formattedCheckedInDate
                                  };
                                  if ((originalFormData.expected_check_in_at ?? null) === (formattedCheckedInDate ?? null)) {
                                    delete _newFormData.expected_check_in_at;
                                  }
                                  return _newFormData;
                                });
                              }}/>
                          </div>
                          </span>
                    }
                    {(formData.status === 'checked_in' || formData.status === 'checked_out') &&
                      <span className="p-d-block fake-input">
                        {moment(formData.checked_in_at).format(t('YYYY-MM-DD'))}
                      </span>
                    }
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-6">
                <Field name="checked_out_at" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="checked_out_at"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {formData?.status?.toLowerCase() === 'checked_out'
                        ? t('departed')
                        : t('expected_departure')}
                    </label>
                    <span className="p-d-block fake-input">
                        {moment(formData.checked_out_at || publicReservation.reserved_to).format(t('YYYY-MM-DD'))}
                      </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>
            <div className={"p-grid"}>
              <div className="p-col-12 p-lg-4">
                <Field name="birth_place" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="birth_place"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('birth_place')}
                      &nbsp;
                      {requiredFields.includes('birthPlace') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                          <InputText id="birth_place" {...input}
                                     onChange={(e) => {
                                       setFormData({
                                         ...formData,
                                         birth_place: e.target.value
                                       });
                                       setNewFormData((prev) => {
                                         let _newFormData = {
                                           ...prev,
                                           birth_place: e.target.value
                                         };
                                         if ((originalFormData.birth_place ?? null) === (e.target.value ?? null)) {
                                           delete _newFormData.birth_place;
                                         }
                                         return _newFormData;
                                       });
                                     }}
                                     value={formData.birth_place}
                                     disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-4">
                <Field name="id_type" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="id_type"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('id_type')}
                      &nbsp;
                      {requiredFields.includes('idType') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <Dropdown  options={[
                              {
                                name: t('id_card'),
                                value: 'ID_CARD',
                              },
                              {
                                name: t('passport'),
                                value: 'PASSPORT',
                              },
                              {
                                name: t('driver_license'),
                                value: 'DRIVER_LICENSE',
                              },
                              {
                                name: t('other'),
                                value: 'OTHER',
                              }
                            ]}
                                      filter
                                      optionLabel="name"
                                      optionValue="value"
                                      id={"id_type"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          id_type: e.value
                                        });
                                        setNewFormData((prev) => {
                                          let _newFormData = {
                                            ...prev,
                                            id_type: e.value
                                          };
                                          if ((originalFormData.id_type ?? null) === (e.value ?? null)) {
                                            delete _newFormData.id_type;
                                          }
                                          return _newFormData;
                                        });
                                      }}
                                      value={formData.id_type}
                                      disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                            />
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-4">
                <Field name="id_number" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="id_number"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('id_number')}
                      &nbsp;
                      {requiredFields.includes('idNumber') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <InputText id="id_number" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           id_number: e.target.value
                                         });
                                         setNewFormData((prev) => {
                                           let _newFormData = {
                                             ...prev,
                                             id_number: e.target.value
                                           };
                                           if ((originalFormData.id_number ?? null) === (e.target.value ?? null)) {
                                             delete _newFormData.id_number;
                                           }
                                           return _newFormData;
                                         });
                                       }}
                                       value={formData.id_number}
                                       disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-3">
                <Field name="zip_code" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="zip_code"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('zip_code')}
                      &nbsp;
                      {requiredFields.includes('zipCode') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <InputText id="zip_code" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           zip_code: e.target.value
                                         });
                                         setNewFormData((prev) => {
                                           let _newFormData = {
                                             ...prev,
                                             zip_code: e.target.value
                                           };
                                           if ((originalFormData.zip_code ?? null) === (e.target.value ?? null)) {
                                             delete _newFormData.zip_code;
                                           }
                                           return _newFormData;
                                         });
                                       }}
                                       value={formData.zip_code}
                                       disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-9">
                <Field name="address" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="address"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('address')}
                      &nbsp;
                      {requiredFields.includes('address') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <InputText id="address" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           address: e.target.value
                                         });
                                         setNewFormData((prev) => {
                                           let _newFormData = {
                                             ...prev,
                                             address: e.target.value
                                           };
                                           if ((originalFormData.address ?? null) === (e.target.value ?? null)) {
                                             delete _newFormData.address;
                                           }
                                           return _newFormData;
                                         });
                                       }}
                                       value={formData.address}
                                       disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-4">
                <Field name="company_name" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="company_name"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('company_name')}
                      &nbsp;
                      {requiredFields.includes('companyName') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <InputText id="company_name" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           company_name: e.target.value
                                         });
                                         setNewFormData((prev) => {
                                           let _newFormData = {
                                             ...prev,
                                             company_name: e.target.value
                                           };
                                           if ((originalFormData.company_name ?? null) === (e.target.value ?? null)) {
                                             delete _newFormData.company_name;
                                           }
                                           return _newFormData;
                                         });
                                       }}
                                       value={formData.company_name}
                                       disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-4">
                <Field name="email" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="email"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('email')}
                      &nbsp;
                      {requiredFields.includes('email') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <InputText id="email" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           email: e.target.value
                                         });
                                         setNewFormData((prev) => {
                                           let _newFormData = {
                                             ...prev,
                                             email: e.target.value
                                           };
                                           if ((originalFormData.email ?? null) === (e.target.value ?? null)) {
                                             delete _newFormData.email;
                                           }
                                           return _newFormData;
                                         });
                                       }}
                                       value={formData.email}
                                       disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-4">
                <Field name="phone" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="phone"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('phone')}
                      &nbsp;
                      {requiredFields.includes('phone') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <InputText id="phone" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           phone: e.target.value
                                         });
                                         setNewFormData((prev) => {
                                           let _newFormData = {
                                             ...prev,
                                             phone: e.target.value
                                           };
                                           if ((originalFormData.phone ?? null) === (e.target.value ?? null)) {
                                             delete _newFormData.phone;
                                           }
                                           return _newFormData;
                                         });
                                       }}
                                       value={formData.phone}
                                       disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className="p-col-12 p-lg-12">
                <Field name="note" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="note"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>
                      {t('note')}
                      &nbsp;
                      {requiredFields.includes('note') &&
                        <>*</>
                      }
                    </label>
                    <span className="p-d-block">
                            <InputText id="note" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           note: e.target.value
                                         });
                                         setNewFormData((prev) => {
                                           let _newFormData = {
                                             ...prev,
                                             note: e.target.value
                                           };
                                           if ((originalFormData.note ?? null) === (e.target.value ?? null)) {
                                             delete _newFormData.note;
                                           }
                                           return _newFormData;
                                         });
                                       }}
                                       value={formData.note}
                                       disabled={!formData.firstname && !formData.lastname && !formData.birth_date}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>
            {customFields && customFields[0] &&
              <>
                <hr/>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-12 p-col-align-center"}>
                    <h3>
                      {t('other')}
                    </h3>
                  </div>
                </div>
                <div className={"p-grid"}>
                  {customFields.map((field, index) => {
                    if (field.related_to === 'RELATED_TO_CUSTOMER') {
                      return (
                        <div className={"p-col-12 p-lg-6"}>
                          <div className="p-field p-fluid">
                            <label htmlFor={field.name}>{t(field.label)}</label>
                            <span className="p-d-block">
                                      <InputText id={field.name}
                                                 onChange={(e) => {
                                                   setFormData({
                                                     ...formData,
                                                     [field.name]: e.target.value
                                                   });
                                                   setNewFormData((prev) => {
                                                     let _newFormData = {
                                                       ...prev,
                                                       [field.name]: e.target.value
                                                     };
                                                     if ((originalFormData[field.name] || originalFormData?.additional_answers?.[field.name]?.value || '') === (e.target.value || '')) {
                                                       delete _newFormData[field.name];
                                                     }
                                                     return _newFormData;
                                                   });
                                                 }}
                                                 value={formData[field.name] || formData?.additional_answers?.[field.name]?.value || ''}
                                      />
                                    </span>
                          </div>
                        </div>
                      )
                    }
                  })}
                </div>
              </>
            }
          </div>
        </form>
      )}/>
      <Dialog header={t('cfields_dialog')}
              visible={showCFieldsDialog}
              style={{width: '60vw'}}
              breakpoints={{'960px': '85vw', '641px': '95vw'}}
              dismissableMask={false}
              closable={false}
              onHide={() => {
                navigateAfterGuestSave();
              }}>
        <div className={"p-grid"}>
          {CFields && CFields[0] &&
            <>
              {CFields.map((field, index) => {
                if (field.type.includes("Text")) {
                  return (
                    <div key={field.name + index} className={"p-col-12 p-lg-6"}>
                      <div className="p-field p-fluid">
                        <label htmlFor={field.name}>{t(field.name)}</label>
                        <span className="p-d-block">
                          <InputText id={field.name}
                                     onChange={(e) => {
                                       setCFormData({
                                         ...CFormData,
                                         [field.name]: e.target.value
                                       })
                                     }}
                                     value={CFormData[field.name]}
                          />
                        </span>
                      </div>
                    </div>
                  )
                }
                if (field.type.includes("Enum")) {
                  return (
                    <div key={field.name + index} className={"p-col-12 p-lg-6"}>
                      <div className="p-field p-fluid">
                        <label htmlFor={field.name}>{t(field.name)}</label>
                        <span className="p-d-block">
                          <Dropdown options={COptions[field.name]}
                                    filter
                                    optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                    optionValue="value"
                                    id={field.name}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setCFormData({
                                        ...CFormData,
                                        [field.name]: e.value
                                      })
                                    }}
                                    value={CFormData[field.name]}
                          />
                        </span>
                      </div>
                    </div>
                  )
                }
              })}
            </>
          }
        </div>
        <div className={"p-d-flex p-jc-end p-mt-3"}>
          <Button type="button"
                  label={t('cancel_cfields')}
                  className="p-button-warning p-mr-2"
                  onClick={() => {
                    setShowCFieldsDialog(false);
                    navigateAfterGuestSave();
                  }}
          />
          <Button type="button"
                  label={t('save_cfields')}
                  icon={"pi pi-save"}
                  className={"p-button-success"}
                  loading={loading}
                  onClick={() => {
                    saveGuestCountrySpecificData();
                  }}
          />
        </div>
      </Dialog>

    </>
  )
}
export default withTranslation('common')(_FM_ReservationGuestFormComponent);
